import React from "react";
import logo from "../../../../../assets/Skydive/skydive_extreme.jpeg"

const VerticalScroll = () => {
  return (
    <div>
    <div className="media-display-layout" style={{display: "flex", flexDirection: "row"}}>
      <div style={{width: "80%", height: "100%"}}>
        {logo && <img src={logo} alt="Logo" className="st-profile-logo"style={{width: "100%", height: "100%"}}/>}
      </div>
      <div style={{display: "flex", flexDirection: "column", width: "20%", height: "100%", background: "purple"}}>
          <div style={{width: "100%", height: "50%", background: "red"}}></div>
          <div style={{width: "100%", height: "50%", background: "green"}}></div>
      </div>
    </div>
      <div className="horizontal-scroll" style={{color: "darkgray"}}>➡️ Vertical Scroll Gallery</div>
    </div>
  );
};

export default VerticalScroll;